<template>
    <div class="stock-card">
        <!-- NEW 标签 -->
        <Badge v-if="showBadge" class="stock-card__badge" :text="badgeText" type="success" />
        <TopRankBadge v-else-if="rank" class="stock-card__badge" :text="`TOP${rank}`" />

        <!-- 头部区域 - 黄色背景 -->
        <a class="stock-card__header" :class="{ 'stock-card__header--new': showBadge }">
            <slot name="header" />
        </a>

        <!-- 内容区域 - 白色背景 -->
        <div class="stock-card__content">
            <slot name="content" />
        </div>
    </div>
</template>

<script >
import Badge from '../Badge.vue';
import TopRankBadge from '../TopRankBadge.vue';
const __sfc_main = {};
__sfc_main.props = {
  rank: {
    type: Number,
    default: 0
  },
  showBadge: {
    type: Boolean,
    default: false
  },
  badgeText: {
    type: String,
    default: 'NEW'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  return {};
};
__sfc_main.components = Object.assign({
  Badge,
  TopRankBadge
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped>
.stock-card {
    position: relative;
    border-radius: 0.2rem;
    overflow: hidden;
    border: 0.02rem solid #ffd7a8;

    &__badge {
        position: absolute;
        top: 0rem;
        left: 0rem;
        z-index: 1;
    }

    &__header {
        display: block;
        padding: 0.5rem 0.2rem;
        background: linear-gradient(180deg, #fff0d3 0%, #fff0d3 100%);
        &--new {
            padding: 0.65rem 0.2rem 0.5rem;
        }
    }

    &__content {
        padding: 0.35rem 0.2rem 0.3rem;
        background: #fff;
    }
}
</style>
